import React from "react";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import classes from "./MobileCoachProfileDetailCard.module.css";
import coachDemoImg from "../../assets/images/coachDemoImg.png";
import StarRatings from "react-star-ratings";

const MobileCoachProfileDetailCard = ({ userData }) => {
  return (
    <div>
      {" "}
      <div className={`${[classes.cardHeader].join(" ")}`}>
        <div className={`${[classes.cardImg].join(" ")}`}>
          <img src={coachDemoImg} alt="" />
        </div>
        <div>
          <h3 className={`${[classes.name].join(" ")}`}>
            <span
              style={{
                color: Colors.neutralShadesOfNero,
                ...Fonts.h4,
                fontSize: "26px",
              }}
            >
              {userData?.displayName?.split(" ")[0]}
            </span>
            <span
              style={{
                color: Colors.neutralShadesOfNero,
                ...Fonts.h4,
                fontSize: "26px",
              }}
            >
              {userData?.displayName?.split(" ")[1]}
            </span>
          </h3>
        </div>
      </div>
      <div className={` ${[classes.details].join(" ")}`}>
        <span className={classes.starRating}>
          <StarRatings
            starRatedColor={Colors.mainShadeOfRed}
            starEmptyColor={Colors.neutralShadesOfGainsboro}
            rating={1}
            starDimension={"20px"}
            numberOfStars={1}
          />
        </span>

        <span
          className={`${[classes.rating].join(" ")}`}
          style={{
            color: Colors.neutralShadesOfNero,
            ...Fonts.otherSemiBold,
            fontSize: 14,
          }}
        >
          {(userData?.rating).toFixed(1)}
        </span>
        <a
          className={`${[classes.reviews].join(" ")}`}
          style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p2 }}
          href
        >
          ({userData?.review.length} reviews)
        </a>
        <span
          className={`${[classes.break].join(" ")}`}
          style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
        />

        <span
          style={{
            color: Colors.neutralShadesOfNero,
            ...Fonts.p2,
            fontFamily: "inter-600",
          }}
        >
          {userData?.sport} coach
        </span>
        <span
          className={`${[classes.break].join(" ")}`}
          style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
        />
        <span
          style={{
            color: Colors.neutralShadesOfNero,
            ...Fonts.p2,
            fontFamily: "inter-600",
          }}
        >
          {userData?.city}
        </span>
      </div>
    </div>
  );
};

export default MobileCoachProfileDetailCard;

MobileCoachProfileDetailCard.defaultProps = {
  userData: {
    photo: coachDemoImg,
    displayName: "Michael Baumgardner",
    distance: "0.6 m away",
    city: "New York",
    lat: "",
    lng: "",
    aboutMe:
      "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis",
    price: 75,
    rating: 5,
    sport: "Tennis",
    review: [{}, {}, {}, {}, {}, {}, {}],
  },
};
